import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import "./DocumentSetting.css";

const SubcategoryAddForm = ({ categoryId, onSave, onCancel, editData = null }) => {
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const isEditing = !!editData;
  
  // Initialize form with data if editing
  useEffect(() => {
    if (editData && editData.sub_category) {
      setName(editData.sub_category);
    }
  }, [editData]);
  
  const handleSave = async () => {
    setError(null);
    if (!name.trim()) return;
    setIsSubmitting(true);
    try {
      await onSave(categoryId, name, editData);
      setName('');
    } catch (error) {
      setError(error?.response?.data?.message || "Something went wrong! Please try again later.");
      console.error("Error saving subcategory:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="subcategory-form-wrapper">
      {console.log("error***", error)}
      <Row className="align-items-center g-0 w-100">
        <Col>
          <Form.Control
            type="text"
            placeholder="Enter subcategory name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={isSubmitting}
            autoFocus
            className="subcategory-input"
          />
          {error && <div className="error-message text-danger">{error}</div>}
        </Col>

        <Col xs="auto" className="d-flex ms-sm-3">
         
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isSubmitting || !name.trim()}
            className="save-btn mb-1"
          >
            <span className="icon-container">
              <span className="icon-check">✓</span>
            </span>
            <span>{isEditing ? isSubmitting ? 'Updating...' : 'Update' : isSubmitting ? 'Saving...' : 'Save'}</span>
          </Button>
          <Button
            variant="light"
            onClick={() => onCancel(categoryId, editData)}
            disabled={isSubmitting}
            className="cancel-btn ms-3 mb-1"
          >
            <span className="icon-container">
              <span className="icon-cross">✕</span>
            </span>
            <span>Cancel</span>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SubcategoryAddForm; 